var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlipAndFall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_14532_170768)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 55,
    height: 56,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 12.5,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#FF8027",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.525 48.546C36.3963 48.7588 36.1884 48.9117 35.947 48.9713C35.7055 49.0308 35.4504 48.992 35.2375 48.8634L24.9446 42.6476C24.7326 42.5185 24.5805 42.3107 24.5215 42.0697C24.4625 41.8287 24.5015 41.5741 24.6298 41.3618C24.7582 41.1494 24.9655 40.9966 25.2063 40.9368C25.4471 40.877 25.7018 40.9151 25.9146 41.0428L36.2076 47.2586C36.4204 47.3872 36.5734 47.5952 36.6329 47.8366C36.6924 48.078 36.6536 48.3332 36.525 48.546ZM46.0572 39.034C46.5493 39.034 47.0304 38.8881 47.4396 38.6147C47.8487 38.3413 48.1676 37.9527 48.3559 37.498C48.5443 37.0434 48.5935 36.5431 48.4975 36.0605C48.4015 35.5778 48.1645 35.1345 47.8165 34.7865C47.4686 34.4386 47.0252 34.2016 46.5426 34.1056C46.0599 34.0096 45.5596 34.0589 45.105 34.2472C44.6504 34.4356 44.2618 34.7545 43.9884 35.1637C43.715 35.5729 43.5691 36.0539 43.5691 36.546C43.5692 37.2059 43.8313 37.8387 44.2979 38.3053C44.7645 38.7719 45.3974 39.034 46.0572 39.034V39.034ZM53.9175 32.0258C53.6864 31.9349 53.4288 31.9385 53.2004 32.036C52.972 32.1335 52.7911 32.3169 52.6968 32.5467L50.0113 39.2378L49.2032 40.0292H43.581L41.5201 36.1876V29.9425C41.5206 29.8191 41.4968 29.6968 41.4499 29.5827C41.403 29.4685 41.3341 29.3648 41.247 29.2773C41.16 29.1899 41.0565 29.1205 40.9425 29.0732C40.8286 29.0258 40.7064 29.0015 40.583 29.0015C40.4596 29.0015 40.3374 29.0258 40.2235 29.0732C40.1095 29.1205 40.006 29.1899 39.919 29.2773C39.8319 29.3648 39.763 29.4685 39.7161 29.5827C39.6692 29.6968 39.6454 29.8191 39.6459 29.9425V36.4236C39.6457 36.5782 39.6841 36.7303 39.7574 36.8664L42.3133 41.6337L39.4982 44.9066L36.9539 39.0506C36.9056 38.9411 36.8371 38.8417 36.7521 38.7576L30.1977 32.2976C30.0204 32.1249 29.7819 32.0293 29.5343 32.0318C29.2867 32.0342 29.0502 32.1345 28.8763 32.3108C28.7024 32.487 28.6053 32.7249 28.6062 32.9725C28.6071 33.2201 28.7059 33.4573 28.881 33.6323L35.306 39.9653L38.9869 48.4353C39.0599 48.6027 39.1802 48.7451 39.333 48.8452C39.4858 48.9452 39.6644 48.9985 39.8471 48.9984H42.3422C42.5873 48.9984 42.8226 48.9026 42.9981 48.7315L51.4633 40.4405C51.5561 40.3494 51.6292 40.2403 51.6781 40.1198L54.4385 33.2465C54.5309 33.0155 54.5279 32.7573 54.4303 32.5285C54.3326 32.2997 54.1482 32.119 53.9176 32.0258H53.9175Z",
    fill: "#FF8027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_14532_170768",
    x: 0,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14532_170768"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_14532_170768",
    result: "effect2_dropShadow_14532_170768"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_14532_170768",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlipAndFall);
export default __webpack_public_path__ + "static/media/slip-and-fall.e85a5bc80d18451cedaef4781a507d5e.svg";
export { ForwardRef as ReactComponent };